module.exports = __webpack_public_path__ + "static/media/6@3x.a727ec3c.png";